<template>
    <b-card no-body>
        <b-card-header class="border-0">
            <h3 class="mb-0">{{ $t('empresas') }}</h3>
        </b-card-header>

        <el-table class="table-responsive table" header-row-class-name="thead-light" :data="tableData">
            <el-table-column :label="$t('nombre')" prop="nombre" min-width="180px">
                <template v-slot="{ row }">
                    <span class="status">{{ row.nombre }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('rut')" min-width="160px" prop="rut">
                <template v-slot="{ row }">
                    <span class="status">{{ row.rut }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('industria')" min-width="150px" prop="industria">
                <template v-slot="{ row }">
                    <span class="status">{{ row.industria }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('direccion')" min-width="150px" prop="direccion">
                <template v-slot="{ row }">
                    <span class="status">{{ row.direccion }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('region')" min-width="150px" prop="region">
                <template v-slot="{ row }">
                    <span class="status">{{ row.region }}</span>
                </template>
            </el-table-column>
            <el-table-column :label="$t('accion')" min-width="130px" prop="action">
                <template v-slot="{ row }">
                    <b-row>
                        <b-col>
                            <router-link :to="{ name: 'empresa-detalle', params: { id: row.id } }">
                                <a variant="primary" class="btn-create-new">
                                    <i class="fas fa-eye"></i>
                                </a>
                            </router-link>
                        </b-col>
                        <b-col>
                            <a @click="deleteRow(row.id)" variant="primary" class="btn-create-new">
                                <i class="fas fa-trash" style="color: red; cursor: pointer;"></i>
                            </a>
                        </b-col>
                    </b-row>
                </template>
            </el-table-column>
        </el-table>

        <!-- <b-card-footer class="py-4 d-flex justify-content-end">
            <base-pagination v-model="currentPage" :per-page="10" :total="50"></base-pagination>
        </b-card-footer> -->
    </b-card>
</template>
<script>

import empresaService from '@/api/empresaService';
import { Table, TableColumn } from 'element-ui'
import utilsService from '@/api/utilsService';

export default {
    name: 'empresa-table',
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        rol() {
            return utilsService.getRol();
        }
    },
    data() {
        return {
            tableData: [],
            currentPage: 1
        };
    },
    async beforeMount() {
        try {
            this.tableData = await empresaService.getAll();
        } catch (error) {
            console.error('Error fetching ingresos:', error);
        }
    },
    methods: {
        deleteRow(id) {
            Swal.fire({
                title: this.$t('estas_seguro'),
                html: `<h4><i><span style="color: red;">*</span> ${this.$t("atencion_eliminar")} </i></h4>`,
                text: this.$t('confirma_eliminar'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: this.$t('si_eliminar'),
                cancelButtonText: this.$t('cancelar')
            }).then(async (result) => {
                if (result.isConfirmed) {

                    Swal.fire({
                        html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">Eliminando...</h3>
                        </div>
                    </div>`,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    });

                    const response = await empresaService.deleteBy(id);
                    if (!response) {
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: this.$t('error')
                        });
                        return;
                    }
                    this.tableData = await empresaService.getAll();

                    Swal.fire({
                        text: this.$t('eliminado_correctamente'),
                        icon: "success",
                        showConfirmButton: false,
                        timer: 2000,
                        background: '#f8f9fa',
                        customClass: {
                            title: 'swal-title',
                            icon: 'swal-icon',
                        },
                    });
                }
            });

        },
    }
}
</script>
